import type { CheckboxSchemaType } from '@vedalib/editor/lib/brand'
import styled, { css } from 'styled-components'

import { border } from 'services/Branding/common.styled'
import type { ElementStyleCss } from 'services/Branding/types'

const getBgColor = (
  $styles: ElementStyleCss<CheckboxSchemaType>,
  $checked: boolean,
  $disabled?: boolean,
) => {
  if ($disabled) {
    return css`
      background-color: ${$styles.checkboxDisabled.backgroundColor};
    `
  }
  if ($checked) {
    return css`
      background-color: ${$styles.checkboxSelected.backgroundColor};
    `
  }
  return css`
    background-color: ${$styles.checkbox.backgroundColor};
  `
}

const getTransformScale = ($styles: ElementStyleCss<CheckboxSchemaType>) => {
  const defaultScale = 0.7
  const defaultSize = 24
  const width = $styles.checkbox.width
  if (typeof width === 'number') {
    return `translate(-50%, -50%) scale(${((width * defaultScale) / defaultSize).toFixed(2)})`
  }
  if (typeof width === 'string') {
    return `translate(-50%, -50%) scale(${((parseInt(width) * defaultScale) / defaultSize).toFixed(2)})`
  }
  return `translate(-50%, -50%) scale(${defaultScale})`
}

export const MarkStyled = styled.div<{
  $styles: ElementStyleCss<CheckboxSchemaType>
  $checked: boolean
  $disabled?: boolean
}>`
  position: relative;
  width: ${({ $styles }) => $styles.checkbox.width};
  height: ${({ $styles }) => $styles.checkbox.width};
  flex-shrink: 0;
  margin-right: 8px;
  ${({ $styles }) => border($styles.checkboxBorder)}
  border-color: ${({ $styles, $disabled }) =>
    $disabled ? $styles.checkboxBorder.color : $styles.checkboxBorder.borderColor};
  ${({ $styles, $checked, $disabled }) => getBgColor($styles, $checked, $disabled)};
  &:after {
    content: '';
    position: absolute;
    display: ${({ $checked }) => ($checked ? 'block' : 'none')};
    top: 50%;
    left: 50%;
    width: 20px;
    height: 20px;
    transform: ${({ $styles }) => getTransformScale($styles)};
    background-color: ${({ $styles, $disabled }) =>
      $disabled ? $styles.checkboxDisabled.color : $styles.iconSelected.backgroundColor};
    mask-image: url("data:image/svg+xml,%3Csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3E%3Cpath%20d='M2.78%2011.79L7.13%2015.94L17.23%205.3'%20stroke='black'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'/%3E%3C/svg%3E");
  }
`

export default MarkStyled
